import React from 'react';
import { Paginator } from './Paginator';
export class Table extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'w-full rounded-lg shadow-xs' },
                    React.createElement("div", { className: `${this.props.className} w-full overflow-x-auto bg-base-800`, style: this.props.style },
                        React.createElement("table", { className: 'w-full whitespace-no-wrap' },
                            React.createElement("tbody", { className: 'bg-base-800 border-b border-base-700 divide-y divide-base-700' }, this.props.children))),
                    React.createElement(Paginator, { page: this.props.page, rowCount: this.props.rowCount, rowsPerPage: this.props.rowsPerPage, onChangePage: this.props.onChangePage }))));
        };
    }
}
